import React from 'react'

import { formatDate } from '../../../../../helpers/helper-date'
import { TextFeedbackProps } from './props'
import { Container, Content, Header } from './styles'

const TextFeedback = ({ data }: TextFeedbackProps) => (
  <Container>
    <Header>
      <h2>{data?.client.name}</h2>
      <p>
        {`${formatDate(new Date(data?.createdAt as string), 'DD/MM/YYYY')} | 
        ${formatDate(new Date(data?.createdAt as string), 'HH')}h`}
      </p>
    </Header>
    <Content>
      <h3>{data?.assessment.title}</h3>
      <p>{data?.answer}</p>
    </Content>
  </Container>
)

export default TextFeedback
